import { ButtonFullscreen } from "../buttons/button-fullscreen/ButtonFullscreen";
import { ButtonSubtitles } from "../buttons/button-subtitles/ButtonSubtitles";
import "./sceneCotrols.css";

type ComponentProps = {
  toggleSubtitles: () => void;
  showSubtitles: boolean;
  isFullscreenAvailable: boolean;
  isFullscreen: boolean;
  toggleFullscreen: () => void;
};

export function SceneControls({
  toggleSubtitles,
  showSubtitles,
  isFullscreenAvailable,
  isFullscreen,
  toggleFullscreen,
}: ComponentProps) {
  return (
    <nav id="sceneControls">
      <ul>
        <li>
          <ButtonSubtitles
            onClick={toggleSubtitles}
            showSubtitles={showSubtitles}
          />
        </li>
        {isFullscreenAvailable && (
          <li>
            <ButtonFullscreen
              onClick={toggleFullscreen}
              isFullscreen={isFullscreen}
            />
          </li>
        )}
      </ul>
    </nav>
  );
}
